import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './reducers/userReducer';
import authReducer from './reducers/authReducer';
import patientReducer from './reducers/patientReducer';
import payerReducer from './reducers/payerReducer';
import claimReducer from './reducers/claimReducer';
import callReducer from './reducers/callReducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'auth'], // Only persist user and auth data (not patients, payers or claims)
};

const persistedUserReducer = persistReducer(persistConfig, userReducer);
const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    auth: persistedAuthReducer,
    patients: patientReducer, // Don't persist patient data
    payers: payerReducer, // Don't persist payer data
    claims: claimReducer, // Don't persist claim data
    calls: callReducer, // Don't persist call data
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
